import C from './container'
import GallerySendFilesMessage from './on_queue_container'
export { GallerySendFilesMessage }
export default C